/**
 * Paso5.js
 */

//Dependencies
import ProgressBar from 'react-customizable-progressbar'
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import $ from 'jquery';
import { onBoardingDigital } from '../../actions/actions';

//material-ui
import Grid from '@material-ui/core/Grid';
import LinearProgress from '@material-ui/core/LinearProgress';

//Assets
import face from '../../static/img/face.png';
import listo from '../../static/img/listo.png';
//Services
import { processToken } from './services/tokenService';
import { processIdClientAnalytics } from './services/pixelService';
import { storeUrlRiesgoNet } from './services/riesgoNetService';

import { processFlow } from './services/flowService';
import { Layout } from './layout/Layout';

class PantallaEspera extends Component {
    constructor(props) {
        super(props);
        this.state = {
            progreso: 0
        }
        this.onLoad = this.onLoad.bind(this);
        this.validateFlow = this.validateFlow.bind(this);
        this.setSiguientePaso = this.setSiguientePaso.bind(this);
        this.paso = 10;
    }

    componentWillMount() {
        this.validateFlow();
        this.conectarSSE();
        processIdClientAnalytics('cargando-venta');
    }

    componentDidUpdate() {
        $(".load").fadeOut(700);
    }

    onLoad() {
    }

    validateFlow() {
        processFlow(this.props.history, this.paso);
    }



    conectarSSE() {
        //const sse = new EventSource('/api/sse/stream-sse-mvc');
        const sse = new EventSource(localStorage.getItem('url') + '/api/vu/ventaOperation');
        //const sse = new EventSource('http://localhost:8080/api/vu/ventaOperation');
        //const sse = new EventSource('http://localhost:8080/api/sse/stream-sse-mvc');
        let completed = false;
        sse.onmessage = (e) => {
            //String to JSON
            let respuesta = JSON.parse(e.data);
            if(respuesta && respuesta.code == 200) {
                this.setState({progreso: respuesta.progress});
                if(respuesta.progress >= 80) {
                    sse.close();
                    completed = true;
                    this.setSiguientePaso();
                    this.props.history.push('/felicitaciones')
                }
            } else {
                
                if(sessionStorage.getItem('tipoFlujo') != 'standalone'){
                    storeUrlRiesgoNet(this.props.history).then(() => {
                        this.props.history.push('/error-servicio')
                    });
                }else if(sessionStorage.getItem('tipoFlujo') == 'standalone'){
                    storeUrlRiesgoNet(this.props.history).then(() => {
                        this.props.history.push('/error-standalone')
                    });
                }        
            }
            
        }
        sse.onerror = (e) => {

            console.error(e);
     
            if(!completed) { 
                sse.close();
                if(sessionStorage.getItem('tipoFlujo') != 'standalone'){
                    storeUrlRiesgoNet(this.props.history).then(() => {
                        this.props.history.push('/error-servicio')
                    });
                }else if(sessionStorage.getItem('tipoFlujo') == 'standalone'){
                    storeUrlRiesgoNet(this.props.history).then(() => {
                        this.props.history.push('/error-standalone')
                    });
                }
            }            
        }
    }

    setSiguientePaso() {
        this.props.dispatch(
            onBoardingDigital(this.paso + 1)
        );
    }

    render() {
        const body = {
            img : {
                src : listo
            },
            slot : (
                <Grid>
                    <ProgressBar
                        progress={this.state.progreso}
                        radius={100}
                        strokeColor="#f47321e0"
                    >
                        <div className="indicator">
                            <span>
                                {this.state.progreso}%
                            </span>
                        </div>
                    </ProgressBar>
                </Grid>
            )
        }
        return (
            <Layout body={body}>
                <Grid container
                    direction="row"
                    justify="center"
                    alignItems="center">
                    <Grid item xs={12}>
                        <div className="content-description">
                            <h5 className="title" >¡Buen Trabajo {this.props.nombre}! Ahora,</h5>
                            <h5 className="title">estamos terminando de <br/> procesar tu solicitud</h5>
                            <h6 className="description">Por favor no cierres la pantalla, hasta que <br/> el proceso termine.</h6>
                        </div>
                    </Grid>                
                </Grid>
            </Layout>
        );
    }
}

const mapStateToProps = function (state) {
    return {
        nombre: state.usuario.nombre,
        correo: state.usuario.correo
    }
}
export default connect(mapStateToProps)(PantallaEspera);


// WEBPACK FOOTER //
// ./src/components/OnBoarding/PantallaEspera.js